export const INTEGER_MIN = -999999;
export const INTEGER_MAX = 999999;
